import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useMerchant } from "@/hooks/useMerchant";
import { useProtectTRPC } from "../trpc";

// The list does not refetch while the wizard is open, so the order and the
// slider math cannot shift under the merchant. A rent changed by the nightly
// sync shows up at submit as QUOTE_CHANGED.
export function useInductionPreApproved() {
  const { merchant } = useMerchant();
  const trpc = useProtectTRPC();
  const queryClient = useQueryClient();
  const rentalsMerchantId = merchant?.id ?? "";

  const { data, isPending, isError, refetch } = useQuery({
    ...trpc.induction.listPreApproved.queryOptions({ rentalsMerchantId }),
    enabled: !!rentalsMerchantId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  // Fetches the list now, whatever its age, and returns it. For after a
  // failed `submit`, when the cached list is known to be out of date.
  const refresh = () =>
    queryClient.fetchQuery({
      ...trpc.induction.listPreApproved.queryOptions({ rentalsMerchantId }),
      staleTime: 0,
    });

  return {
    screenings: data?.screenings,
    isLoading: !rentalsMerchantId || isPending,
    isError,
    refetch,
    refresh,
  };
}
